<template>
  <v-slide-group v-model="model" class="my-2" :show-arrows="false">
    <v-slide-item v-for="(item,i) in message.carousel" :key="i">
      <v-card :style="{'border-radius':'20px'}" :width="MobileSize ? 250 : undefined" class="mx-1" outlined>
        <v-card width="300px" height="150px">
          <v-img :src="item.thumbnailImageUrl === null ? '' : item.thumbnailImageUrl" v-if="img" @error="img = !img" width="300px" height="150px"></v-img>
        </v-card>
        <v-card width="300px" flat tile color="grey lighten-2">
          <v-card-title>{{item.title}}</v-card-title>
          <v-card-subtitle>{{item.subtitle}}</v-card-subtitle>
          <v-card-text>
            <v-row v-for=" (button,i) in item.choices" :key="i" class="py-0 my-0">
              <v-col cols="12" class="py-0 pb-2">
                <v-btn block color="white black--text">{{button.split('[')[0]}}</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card>
    </v-slide-item>
  </v-slide-group>
</template>
<script>
export default {
  props: ["message"],
  computed: {
    MobileSize: {
      get() {
        const { xs } = this.$vuetify.breakpoint;
        return xs ? true : false;
      },
      set() {}
    }
  },
  data() {
    return {
      img: true
    };
  }
};
</script>